import { render, staticRenderFns } from "./UpdateAgentForm.vue?vue&type=template&id=25bfef39&"
import script from "./UpdateAgentForm.vue?vue&type=script&lang=js&"
export * from "./UpdateAgentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports